import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './containers/App';
import './index.css';
import './locale/i18n';

import { BrowserRouter } from 'react-router-dom';
import store from './store';

import { HelmetProvider } from 'react-helmet-async';
import Maintenance from './containers/Maintenance';
import ProvideAuth from './containers/UseAuth';
import ProvideService from './containers/UseService';
import { ForecastProvider } from './contexts/ForecastContext';
import { isInMaintenance } from './utils/functions';

async function render() {
    ReactDOM.render(
        (await isInMaintenance()) ? (
            <Maintenance />
        ) : (
            <React.StrictMode>
                <HelmetProvider>
                    <Provider store={store}>
                        <ProvideAuth>
                            <BrowserRouter>
                                <ForecastProvider>
                                    <ProvideService>
                                        <App />
                                    </ProvideService>
                                </ForecastProvider>
                            </BrowserRouter>
                        </ProvideAuth>
                    </Provider>
                </HelmetProvider>
            </React.StrictMode>
        ),
        document.getElementById('root')
    );
}

render();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
